import { Dialog } from '@mui/material';
import { ConnectivityDialogBody } from '../shared/ConnectivityDialogBody';

export const ReconnectingDialogComponent = ({ open }: { open: boolean }) => (
  <Dialog open={open}>
    <ConnectivityDialogBody variant="reconnecting" />
  </Dialog>
);
